import type { BookingPlace } from './booking-logistics';

export type HomeHotel = BookingPlace & { cities: string[]; zone: string };
const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

/** Zones come from the provider's place text, not the tour's departure city. */
export function hotelZone(place: BookingPlace, other: string): string {
  const text = normalize(`${place.title} ${place.address ?? ''}`);
  if (/zona hotelera|hotel zone|boulevard kukulcan|blvd\.? kukulcan/.test(text)) return 'Zona Hotelera Cancún';
  if (/playa del carmen|playacar/.test(text)) return 'Playa del Carmen';
  if (/tulum/.test(text)) return 'Tulum';
  if (/puerto morelos/.test(text)) return 'Puerto Morelos';
  if (/akumal/.test(text)) return 'Akumal';
  if (/cancun/.test(text)) return 'Cancún';
  if (/holbox/.test(text)) return 'Holbox';
  return other;
}

export function groupHomeHotels(sources: { city: string; places: BookingPlace[] }[], other: string): HomeHotel[] {
  const hotels = new Map<string, HomeHotel>();
  for (const source of sources) for (const place of source.places) {
    const key = `${place.id}:${normalize(place.title)}`;
    const existing = hotels.get(key);
    if (existing) { if (!existing.cities.includes(source.city)) existing.cities.push(source.city); }
    else hotels.set(key, { ...place, cities: [source.city], zone: hotelZone(place, other) });
  }
  return [...hotels.values()].sort((a,b) => a.zone.localeCompare(b.zone) || a.title.localeCompare(b.title));
}

export function searchHomeHotels(hotels: HomeHotel[], query: string) {
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  return hotels.filter(h => words.every(word => normalize(`${h.title} ${h.address ?? ''} ${h.zone}`).includes(word)));
}